import { Theme } from "@mui/material";
import { DateTime } from "luxon";
import {
  holidays2025,
  holidays2026,
  holidays2027,
  SchedulePublicHolidays,
  SchedulePublicHolidayType
} from "../../schedule-calendar-holidays";
import { MbscCalendarEvent, MbscPageLoadedEvent } from "@mobiscroll/react";
import { getHolidayEventColor } from "./schedule-calendar-colors";

// filtering only federal public holidays for now
const ALL_PUBLIC_HOLIDAYS: SchedulePublicHolidays[] = [
  ...holidays2025,
  ...holidays2026,
  ...holidays2027
].filter(
  holiday =>
    holiday.type === SchedulePublicHolidayType.FEDERAL ||
    holiday.states.includes("Berlin") ||
    holiday.states.includes("Hesse")
);

export function generateHolidaySchedule({
  currentLoadedEvent,
  timezone,
  theme,
  language
}: {
  currentLoadedEvent: MbscPageLoadedEvent | undefined;
  timezone: string;
  theme: Theme;
  language: string;
}) {
  const defaultFirstDay = DateTime.now().setZone(timezone).startOf("month").toJSDate();
  const defaultLastDay = DateTime.now().setZone(timezone).endOf("month").toJSDate();
  const firstDay = currentLoadedEvent?.firstDay ?? defaultFirstDay;
  const lastDay = currentLoadedEvent?.lastDay ?? defaultLastDay;
  const viewStart = DateTime.fromJSDate(firstDay).setZone(timezone).startOf("day");
  const viewEnd = DateTime.fromJSDate(lastDay).setZone(timezone).endOf("day");
  const holidayBgColor = getHolidayEventColor(theme);

  return ALL_PUBLIC_HOLIDAYS.map(holiday => {
    const holidayStart = DateTime.fromISO(holiday.date).setZone(timezone).startOf("day");

    if (holidayStart < viewStart || holidayStart > viewEnd) {
      return null;
    }

    return {
      id: `holiday-${holiday.date}`,
      title: language === "de" ? holiday.names.de : holiday.names.en,
      start: holidayStart.toISO(),
      end: holidayStart.toISO(),
      allDay: true,
      editable: false,
      color: holidayBgColor,
      cssClass: "seedit-schedule-holiday-label"
    } as MbscCalendarEvent;
  }).filter(Boolean) as MbscCalendarEvent[];
}
